export default __webpack_public_path__ + "assets/3f10536feb3a567a9aa02f30aac22aa8.jpg";